<template>
  <div >
    <div class="subheader-wrapper">
     <div class="icon-group d-flex">
        <!-- <i class="fa fa-plus"            @click="addNewRow"           aria-hidden="true"></i> -->
        <div class="icon-btn" :disabled="!selectedRows" @click="deleteRows" >
          <i class="fa fa-trash"              aria-hidden="true"></i>
        </div>
      </div>
    </div>
    <DxDataGrid
      :data-source="dataSource"
      ref="configuratorDataGrid"
      key-expr="lineNumber"
      @editing-start="startEditing"
      @editor-preparing="onEditorPreparing"
      @row-updating="endEditing"
      :show-row-lines="true"
      @selection-changed="onSelectionChanged"
      :show-column-lines="true"
      :row-alternation-enabled="true"
      :allow-column-resizing="true"
      :column-min-width="25"
      :remoteOperations="false"
      :on-cell-prepared="onCellPrepared"
      no-data-text="Add Products to Table"
      width="100%"
      height="500"
      :show-borders="true"
      :column-auto-width="true"
    >
      <!-- <DxSelection
        show-check-boxes-mode="always"
        mode="single"
        maxWidth="25px"
      /> -->
      <DxSelection
        mode="multiple"
        show-check-boxes-mode="always"
      />
      <DxRowDragging
        :allow-reordering="true"
        :on-reorder="onReorder"
      />
      <DxScrolling />
      <DxEditing
        :allow-updating="true"
        mode="cell"
      />
      
      <DxColumn width="50"  data-field="Quantity"       caption="Qty"             header-cell-template="title-header"  cell-template="grid-cell"/>
      <DxColumn :minWidth="150" width="100%" data-field="Description"    caption="Description"     header-cell-template="title-header"  cell-template="grid-cell"/>
      <DxColumn width="75"  data-field="RetailAmount"          caption="Price"          header-cell-template="title-header"  cell-template="grid-cell-amount"/>
      
      <template #title-header="{ data }">
        <div class="header">{{ data.column.caption }}</div>
      </template>
      <template  #grid-cell="{ data }">
          <div class="cell">{{ data.text }}</div>
      </template>
      <template  #grid-cell-amount="{ data }">
          <div class="cell">{{ formatCurrency(data.value) }}</div>
      </template>
    </DxDataGrid>
    <dx-tooltip :ref="tooltipRefName" position="top">
      <div class="tooltipContent">
        <div>{{currentCellToolTip}}</div>
      </div>
    </dx-tooltip>
  </div>
</template>
<script>

import DxDataGrid, {DxSelection, DxEditing, DxScrolling, DxColumn, DxRowDragging}       from 'devextreme-vue/data-grid';

import DxTooltip from "devextreme-vue/tooltip"
import { on, off } from "devextreme/events";

export default {
  name: 'ConfiguratorDataGrid',
  props: {
    dataSource: {
      type: Array,
      default: () => []
    },
    addToOrderlinesWasClicked: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    DxTooltip,
    DxDataGrid, 
    DxColumn,
    DxSelection,
    DxScrolling,
    DxEditing,
    DxRowDragging,
  },
  data() {
    return {
      currentCellToolTip: '',
      tooltipRefName: 'tooltip',
      editing: false,
      selectedRows: null,
      currentColumnEditing: "",
    };
  },
  methods: {
    addNewRow() {
        this.$refs.configuratorDataGrid.instance.addRow();
        this.$refs.configuratorDataGrid.instance.saveEditData();
    },
    formatCurrency(currency){
      if(typeof(currency) !== 'number') return;
      if(currency === 0 || currency === null) return ''
      return `$${currency.toFixed(2)}`;
    },
    onEditorPreparing(e){ 
        if(e.row && !e.row.data.HasMatchingProduct){
          e.editorOptions.disabled = true ;
        }

      // if(e.dataField === 'Discount2'){
      //   e.editorOptions.disabled = e.parentType === "dataRow" && e.row.data.ImportedDiscount2;
      // }   
      // if(e.dataField === 'DealerCost'){
      //   e.editorOptions.disabled = e.parentType === "dataRow" && (e.row.data.ImportedDiscount1 || e.row.data.ImportedDiscount2);
      // }
      // if(e.dataField === 'CustomerCost'){
      //   e.editorOptions.disabled = e.parentType === "dataRow" && e.row.data.ImportedCustomerCost;
      // }

      // if (e.rowType == 'header') {  
      //       e.cellElement.mousemove(function() {  
      //               var headerTitle = e.cellElement.children();  
      //               headerTitle.attr('title', ' ');  
      //               if (headerTitle.get(0).scrollWidth > headerTitle.get(0).clientWidth) {  
      //                   //Display your tooltip here  
      //               }  
      //       })  
      //   }  
    },
    onCellPrepared(e) {
      if (e.rowType === "header" && e.column.caption) {
        var self = this;
        on(e.cellElement, "mouseover", arg => {
            self.currentCellToolTip = e.column.caption;
            self.$refs[self.tooltipRefName].instance.show(arg.target);
        });
        on(e.cellElement, "mouseout", arg => {
          self.$refs[self.tooltipRefName].instance.hide();
        });
      }
      if (e.rowType == "data") {  
          if (!e.data.HasMatchingProduct && e.data.HasMatchingProduct !== undefined) { 
            e.cellElement.style.backgroundColor = 'rgba(255, 0, 0, .3)'; 
          } else if(e.data.HasMatchingProduct === undefined){
            e.cellElement.style.backgroundColor = 'rgba(0, 0, 0, .5)'; 
          }
          // if (e.data.sex === 'Female') { e.cellElement.addClass('Pink'); }  
      }  

    },
    startEditing(e){
      this.editing = true;
      this.currentColumnEditing = e.column.dataField
    },
    endEditing(e){
      this.editing = false;
      console.log('end editing', e, e.component.getCellElement())
      if(this.currentColumnEditing === 'Quantity'){
        this.$emit('checkAndUpdateChildRowsQuantity', e.oldData.Id, e.newData.Quantity)
      }
      
      // this.checkAndUpdateChildRows(e.data.Id)
      // this.$refs.configuratorDataGrid.instance.saveEditData();
    },
    onSelectionChanged(e){
      this.selectedRows = e.selectedRowsData
      // this.$emit('selectedRowsChanged', e.selectedRowsData)
    },
    deleteRows(){
      let deletedRows = []
      this.selectedRows.forEach(row => {
        deletedRows.push(row.lineNumber)
      })
      deletedRows.sort(function(a,b){ return b - a; })
      for (var i = deletedRows.length -1; i >= 0; i--){
        let index = this.dataSource.map(obj => obj.lineNumber).indexOf(deletedRows[i])
        this.dataSource.splice(index,1);
      }
      this.selectedRows = null;
    },
    onReorder(e) {
      var visibleRows = e.component.getVisibleRows(),
        toIndex = this.dataSource.indexOf(visibleRows[e.toIndex].data),
        fromIndex = this.dataSource.indexOf(e.itemData);

      this.dataSource.splice(fromIndex, 1);
      this.dataSource.splice(toIndex, 0, e.itemData);
    }
  },
  watch: {
    addToOrderlinesWasClicked: function(){
      if(this.addToOrderlinesWasClicked){

        this.$refs.configuratorDataGrid.instance.saveEditData();
        console.log('$refs', this.$refs.configuratorDataGrid.instance)
        // this.$refs.configuratorDataGrid.instance.rowUpdated;
        this.$emit('orderlineUpdateComplete')
      }
    }
  },
  created(){
    
  }
};
</script>
<style lang="scss" scoped>
  .header {
    font-size: 16px;
    color: $primary;
  }
  .cell {
    font-size: 14px;
    color: $ss_grey1;
  }

  .icon-btn{
    border: none;
    background-color: transparent;
    padding: 0px;
  }
  .subheader-wrapper{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .icon-group{
      
      color: $primary;
      i{
        margin: 5px;
        cursor: pointer;
      }
    }
  }
</style>